var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllSetName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#FCEDE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3214 57.86C62.9782 57.8614 65.5757 57.0748 67.7853 55.5996C69.9949 54.1245 71.7173 52.0271 72.7347 49.5729C73.7521 47.1187 74.0187 44.4178 73.5008 41.812C72.9829 39.2062 71.7038 36.8126 69.8252 34.9339C67.9467 33.0552 65.5531 31.7759 62.9474 31.2578C60.3416 30.7398 57.6408 31.0062 55.1865 32.0234C52.7321 33.0406 50.6347 34.7628 49.1594 36.9723C47.6841 39.1818 46.8973 41.7792 46.8984 44.436C46.9035 47.9946 48.3193 51.4059 50.8354 53.9223C53.3516 56.4387 56.7629 57.8547 60.3214 57.86Z",
    stroke: "#DC4405",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 68.9336H74.142C77.9876 68.9336 81.6758 70.4613 84.3951 73.1805C87.1143 75.8998 88.642 79.588 88.642 83.4336V89.5136H32V83.4336C32 79.588 33.5277 75.8998 36.247 73.1805C38.9662 70.4613 42.6544 68.9336 46.5 68.9336Z",
    stroke: "#DC4405",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllSetName);
export default __webpack_public_path__ + "static/media/ill_set_name.1f3c18b9723597fbe1e2202e6d57795b.svg";
export { ForwardRef as ReactComponent };